import React from 'react';
import { useDropzone } from 'react-dropzone';
import bytesToMegabytes from 'Utils/BytesToMegaBytes';

const useDropZone = ({ formats = [], maxSize = 50000 }) => {
  const { acceptedFiles, fileRejections, getRootProps, getInputProps } = useDropzone({
    accept: formats,
    maxSize,
  });

  const acceptedFileItems = acceptedFiles.map(file => (
    <p key={file.path} style={{ textAlign: 'center' }}>
      {file.path} - {bytesToMegabytes(file.size)} MB
    </p>
  ));

  const fileRejectionItems = fileRejections.map(({ file }) => (
    <li key={file.path}>
      {file.path} - {bytesToMegabytes(file.size)} MB
    </li>
  ));

  return {
    acceptedFileItems,
    fileRejectionItems,
    acceptedFiles,
    getRootProps,
    getInputProps,
  };
};

export default useDropZone;
